/*
  NÛRA — Shared Intersection Observer
  Loaded once via nura-ritual-hero.liquid (first section on the page).
  All subsequent nura-ritual-* sections add .nura-reveal elements;
  this single observer handles them all.
  Respects prefers-reduced-motion at the observer level — no per-section logic needed.
*/
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduced) {
    /* Make everything visible immediately — skip all reveal logic */
    document.querySelectorAll('.nura-reveal').forEach(function (el) {
      el.classList.add('nura-reveal--visible');
    });
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('nura-reveal--visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );

  function observe() {
    document.querySelectorAll('.nura-reveal:not(.nura-reveal--visible)').forEach(function (el) {
      io.observe(el);
    });
  }

  /* Observe on load and again after Shopify section re-renders in Customizer */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  document.addEventListener('shopify:section:load', observe);
})();
